/* Zepto's personalizer adds a hidden "Item Personalization" fee line next
   to each embroidered item and links the two with a _pc_pricing_ref
   property. Its cart script watches for a fee line whose quantity no
   longer matches its item, fixes it with /cart/change.js and then reloads
   the page. Changing both lines in one /cart/update.js request keeps them
   in step, so the app never has anything to fix. */
window.cartFeeLines = {
  /* lineElements: the rendered cart lines, each carrying data-index,
     data-line-key, data-line-quantity, data-pplr-ref and, on fee lines,
     data-pplr-fee. Returns an updates map for /cart/update.js when the
     line being changed has fee lines linked to it, otherwise null so the
     caller keeps using /cart/change.js. */
  updatesFor: function (lineElements, line, quantity) {
    var elements = Array.prototype.slice.call(lineElements);
    var parent = elements.filter(function (el) {
      return el.dataset.index === String(line);
    })[0];
    if (!parent || !parent.dataset.lineKey || !parent.dataset.pplrRef) return null;
    if (parent.hasAttribute('data-pplr-fee')) return null;

    var newQuantity = parseInt(quantity, 10);
    if (isNaN(newQuantity) || newQuantity < 0) return null;
    var parentQuantity = parseInt(parent.dataset.lineQuantity, 10) || 1;

    var updates = {};
    updates[parent.dataset.lineKey] = newQuantity;
    var feeLines = 0;
    elements.forEach(function (el) {
      if (el === parent || !el.dataset.lineKey) return;
      if (!el.hasAttribute('data-pplr-fee')) return;
      if (el.dataset.pplrRef !== parent.dataset.pplrRef) return;
      var feeQuantity = parseInt(el.dataset.lineQuantity, 10) || 1;
      var perUnit = Math.max(1, Math.round(feeQuantity / parentQuantity));
      updates[el.dataset.lineKey] = newQuantity * perUnit;
      feeLines += 1;
    });
    return feeLines ? updates : null;
  }
};
